import { useSetRecoilState } from 'recoil'
import { stepState } from '../states/messageState'
import { useInViewFooter } from './useInViewFooter'
import { useSendMessage } from './useSendMessage'

export const useRequestFailed = () => {
  const { handleAddSenderParent } = useSendMessage()
  const { handleInViewFooter } = useInViewFooter()
  const setCurrentStep = useSetRecoilState(stepState)

  const requestFailed = async (isFulfilled?: boolean) => {
    const message = `申し訳ございません。${
      isFulfilled
        ? 'こちらの保証は既に使用されている為、利用する事が出来ません。'
        : '頂いた情報では保証契約が見つかりませんでした。\nまたは、保証期間がスタートしていない可能性も考えることができます。'
    }\nさらなるお問い合わせが必要な場合は下記窓口をご確認の上お問合せください。\n【家具インテリア保証に加入の方】\nrakuten-interior-hosho@helloproteger.comまたは0570-039900(受付時間：平日 月〜土 10:00～18:00)\n【その他保証に加入の方】\ncustomer@helloproteger.comまたは0570-081170(受付時間：平日 月〜金 10:00~18:00)`

    await handleAddSenderParent('bot', message)

    handleInViewFooter()
    setCurrentStep('notFoundInquiryCodeOrEmail')
  }

  return { requestFailed }
}
